module.exports = __webpack_public_path__ + "static/img/icon-editor.3efef116.svg";